import { LazyLoader } from "@NextSkyTheme/lazy-load";

document.addEventListener("DOMContentLoaded", function () {
  function addProductEntry(productJson, storedProducts) {
    if (storedProducts === null) storedProducts = [];
    const currentProductID = productJson.toString();
    if (!storedProducts.includes(currentProductID)) {
      storedProducts.unshift(currentProductID);
      if (storedProducts.length > 25) {
        storedProducts.pop();
      }
      localStorage.setItem(
        "recently-viewed-products",
        JSON.stringify(storedProducts)
      );
    } else {
      const index = storedProducts.indexOf(currentProductID);
      if (index > -1) {
        storedProducts.splice(index, 1);
      }
      storedProducts.unshift(currentProductID);
      localStorage.setItem(
        "recently-viewed-products",
        JSON.stringify(storedProducts)
      );
    }
  }

  const prodData = document.querySelector("[data-product-json]");
  if (prodData != null) {
    const productJson = JSON.parse(prodData.innerHTML);
    const storedProducts = JSON.parse(
      localStorage.getItem("recently-viewed-products")
    );
    addProductEntry(productJson, storedProducts);
  }
});

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }
  init() {
    this.connectedCallback();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }
          new LazyLoader(".image-lazy-load");
        })
        .finally(() => {})
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("product-recommendations", ProductRecommendations);

class StickyAddCart extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    const _this = this;
    this.main = document.querySelector(".main-product-section");
    if (!this.main) return;
    const primaryBtn = this.main.querySelector(".block-product__buttons");
    const footer = document.querySelector("footer");
    if (!primaryBtn) return;
    var isVisible = true;
    window.addEventListener("scroll", function () {
      const buttonRect = primaryBtn.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      if (footer) {
        const footerRect = footer.getBoundingClientRect();
        if (footerRect.top < window.innerHeight - 100) {
          _this.classList.remove("show-sticky-cart");
          document.documentElement.classList.remove("show-sticky-cart-active");
          isVisible = true;
        } else {
          if (
            !isVisible &&
            buttonRect.top < viewportHeight &&
            buttonRect.bottom > 0
          ) {
            isVisible = true;
            _this.classList.remove("show-sticky-cart");
            document.documentElement.classList.remove(
              "show-sticky-cart-active"
            );
          } else if (isVisible && buttonRect.bottom <= 0) {
            isVisible = false;
            _this.classList.add("show-sticky-cart");
            document.documentElement.classList.add("show-sticky-cart-active");
          }
        }
      } else {
        if (
          !isVisible &&
          buttonRect.top < viewportHeight &&
          buttonRect.bottom > 0
        ) {
          isVisible = true;
          _this.classList.remove("show-sticky-cart");
          document.documentElement.classList.remove("show-sticky-cart-active");
        } else if (isVisible && buttonRect.bottom <= 0) {
          isVisible = false;
          _this.classList.add("show-sticky-cart");
          document.documentElement.classList.add("show-sticky-cart-active");
        }
      }
    });
  }
}
customElements.define("sticky-add-cart", StickyAddCart);

const infoGallerySlide = () => {
  const gallery = document.querySelectorAll(".info-gallery__card");
  gallery.forEach((e) => {
    e.addEventListener("mouseover", (event) => {
      const currentTarget = event.currentTarget;
      if (!currentTarget.classList.contains("active")) {
        gallery.forEach((el) => {
          el.classList.remove("active");
        });
        currentTarget.classList.add("active");
      }
    });
  });
};
document.addEventListener("shopify:section:load", function () {
  infoGallerySlide();
});
infoGallerySlide();

class ProductUvps extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector(".product-uvps__track");
    this.bar = this.querySelector(".product-uvps__progress-bar");
    if (!this.track || !this.bar) return;

    this.onScroll = () => this.updateProgress();
    this.onResize = () => this.updateProgress();
    this.track.addEventListener("scroll", this.onScroll, { passive: true });
    window.addEventListener("resize", this.onResize, { passive: true });
    this.updateProgress();
  }

  disconnectedCallback() {
    if (this.track && this.onScroll) {
      this.track.removeEventListener("scroll", this.onScroll);
    }
    if (this.onResize) {
      window.removeEventListener("resize", this.onResize);
    }
  }

  updateProgress() {
    if (!this.track || !this.bar) return;
    const { scrollLeft, scrollWidth, clientWidth } = this.track;
    if (scrollWidth <= clientWidth) {
      this.bar.style.width = "100%";
      return;
    }
    const visible = clientWidth / scrollWidth;
    const maxScroll = scrollWidth - clientWidth;
    const ratio = maxScroll > 0 ? scrollLeft / maxScroll : 0;
    const width = (visible + ratio * (1 - visible)) * 100;
    this.bar.style.width = `${Math.max(visible * 100, Math.min(100, width))}%`;
  }
}

if (!customElements.get("product-uvps")) {
  customElements.define("product-uvps", ProductUvps);
}

class CompleteLookCard extends HTMLElement {
  connectedCallback() {
    this.select = this.querySelector("[data-complete-look-size]");
    this.sizeText = this.querySelector("[data-complete-look-size-text]");
    this.input = this.querySelector('input[name="id"]');
    this.button = this.querySelector(".complete-look__add");
    const jsonEl = this.querySelector("[data-complete-look-variants]");
    if (!this.input || !jsonEl) return;

    try {
      this.variants = JSON.parse(jsonEl.textContent);
    } catch (e) {
      this.variants = [];
    }

    this.sizeOptionIndex = Number(this.dataset.sizeOptionIndex || 0);
    this.onSizeChange = () => this.syncVariant();
    this.select?.addEventListener("change", this.onSizeChange);
    this.syncVariant();
  }

  disconnectedCallback() {
    this.select?.removeEventListener("change", this.onSizeChange);
  }

  syncVariant() {
    if (!this.input || !this.variants?.length) return;

    const size = this.select?.value;
    if (this.sizeText && size) {
      this.sizeText.textContent = `Tamanho: ${size}`;
    }

    const idx = this.sizeOptionIndex;
    const currentId = Number(this.input.value);
    const base =
      this.variants.find((v) => v.id === currentId) ||
      this.variants.find((v) => v.available) ||
      this.variants[0];

    let match = null;
    if (size != null && size !== "") {
      match =
        this.variants.find((v) => {
          if (v.options?.[idx] !== size || !v.available) return false;
          if (!base) return true;
          return v.options.every(
            (opt, i) => i === idx || opt === base.options?.[i]
          );
        }) ||
        this.variants.find(
          (v) => v.options?.[idx] === size && v.available
        ) ||
        this.variants.find((v) => v.options?.[idx] === size);
    } else {
      match = this.variants.find((v) => v.available) || this.variants[0];
    }

    if (!match) return;

    this.input.value = match.id;
    this.input.disabled = false;
    if (this.button) {
      this.button.disabled = !match.available;
    }
  }
}

if (!customElements.get("complete-look-card")) {
  customElements.define("complete-look-card", CompleteLookCard);
}
